<pcs-icon *ngIf="data" icon="fast_forward"></pcs-icon>
